var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-base',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('v-main',{staticClass:"grey lighten-3"},[_c('router-view',{attrs:{"name":"appBar"}}),_c('router-view',{attrs:{"name":"filters"}}),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)]},proxy:true}])},[_c('navigation-drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }